import script from "./UserPolicy.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPolicy.vue?vue&type=script&setup=true&lang=js"

import "./UserPolicy.vue?vue&type=style&index=0&id=ac2f766a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac2f766a"]])

export default __exports__